/* Compact hero: reuse the existing platform controller; preserve preview URL parameters. */
(() => {
  const mobile = window.matchMedia('(max-width:749px)');
  const reduced = window.matchMedia('(prefers-reduced-motion:reduce)');
  const plainClick = event => !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
  function focusAndScroll(target, focus) {
    if (focus) {
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({preventScroll:true});
    }
    target.scrollIntoView({behavior:reduced.matches?'auto':'smooth',block:'start'});
  }
  function reveal(panel, focus) {
    const module = panel.closest('[data-lunar-platform-module]');
    if (!module) return false;
    if (mobile.matches) {
      const tab = [...module.querySelectorAll('[data-lunar-platform-tab]')].find(el => el.getAttribute('aria-controls') === panel.id);
      if (tab) tab.click();
    }
    if (panel.hidden) return false;
    focusAndScroll(panel,focus);
    return true;
  }
  function saveHash(hash) {
    if (location.hash === hash) return;
    try { history.pushState(null,'',hash); } catch (_) { location.hash=hash; }
  }
  function followCurrentHash() {
    const target=document.getElementById(location.hash.slice(1));
    if(target?.matches('[data-lunar-platform-panel]')) reveal(target,false);
  }
  function init() {
    document.querySelectorAll('[data-lunar-owner-hero]').forEach(hero => {
      if (hero.dataset.ownerReady === 'true') return;
      hero.dataset.ownerReady='true';
      hero.querySelectorAll('[data-lunar-hero-platform]').forEach(link => {
        link.addEventListener('click',event => {
          if (link.dataset.lunarHeroDestination === 'external' || !plainClick(event)) return;
          const hash=link.getAttribute('href');
          if (!hash?.startsWith('#')) return;
          const panel=document.getElementById(hash.slice(1));
          if (!panel || !reveal(panel,true)) return;
          event.preventDefault();
          saveHash(hash);
        });
      });
      hero.querySelectorAll('[data-lunar-hero-reviews]').forEach(link => {
        link.addEventListener('click',event => {
          if (!plainClick(event)) return;
          const reviews=document.getElementById('lunar-community');
          if (!reviews || reviews.hidden) return;
          event.preventDefault();
          saveHash('#lunar-community');
          focusAndScroll(reviews,true);
        });
      });
    });
    followCurrentHash();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
  window.addEventListener('hashchange',followCurrentHash);
  window.addEventListener('popstate',followCurrentHash);
})();
